import React from 'react';
import { RootState } from '../../store';
import { connect } from 'react-redux';
import SelectInputSimple from '../inputs/select-input-simple';
import { FormattedMessage } from 'react-intl';
import { ISession } from '../../models/pro-sites';
import { CA } from './constants';
import { IWishListItem } from '../../models/wish-list';

interface IBenefitsProps {
    session: ISession | null;
    favorites?: IWishListItem[];
    recentlyViewed?: IWishListItem[];
    selectedAgreement: string;
    handleChange: (e: any) => void;
    needsWishes: boolean;
}

const BenefitsDropdown = ({
    session,
    selectedAgreement,
    favorites,
    recentlyViewed,
    handleChange,
    needsWishes,
}: IBenefitsProps) => {
    const shouldRenderBenefits = () => {
        if (session && session.agreements && session.country === CA) {
            if (needsWishes) {
                if (
                    (favorites && favorites.length > 0) ||
                    (recentlyViewed && recentlyViewed.length > 0)
                ) {
                    return true;
                }
                return false;
            }
            return true;
        }
        return false;
    };
    return (
        <>
            {shouldRenderBenefits() && (
                <div className="row">
                    <div
                        className="form-group col-md-8"
                        style={{
                            textAlign: 'right',
                            paddingRight: '0px',
                        }}
                    >
                        <label
                            className="control-label"
                            style={{
                                paddingTop: '8px',
                                textTransform: 'none',
                                cursor: 'default',
                            }}
                            htmlFor="agreements"
                        >
                            <FormattedMessage id="Benefit_Name" />:
                        </label>
                    </div>

                    <div className="col-md-4">
                        <SelectInputSimple
                            name="agreements"
                            options={session!.agreements.map((agreement) => ({
                                value: agreement.agreementName,
                                text: agreement.agreementName,
                            }))}
                            hasDefaultOption={true}
                            defaultOption={'Select'}
                            value={selectedAgreement}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
const mapStateToProps = (state: RootState) => ({
    session: state.session!.data!,
    favorites: state.wishlists.favorites,
    recentlyViewed: state.wishlists.recentlyViewedProducts,
});

const BenefitsDropdownContainer = connect(mapStateToProps)(BenefitsDropdown);

export default BenefitsDropdownContainer;
